import { startCase } from 'es-toolkit/compat';
import { trackEvent } from 'shared/helpers/Analytics';
import { OfferDeclinePayloadDTO } from './OffersDTO';

type OffersAnalyticsEvent =
  | {
      name: 'CTMS: Viewed Load Offer';
      guid: string;
      is_counter_offer: boolean | null;
    }
  | {
      name: 'Declined Load Offer';
      guid: string;
      payload: OfferDeclinePayloadDTO;
    }
  | { name: 'Accepted Load Offer'; guid: string }
  | { name: 'Carrier Clicked Learn More Button' }
  | { name: 'Carrier Clicked Place Bid on Load Offer' };

export function trackOffersEvent(event: OffersAnalyticsEvent) {
  const baseParams = { is_public_offer: false };

  switch (event.name) {
    case 'Accepted Load Offer': {
      const { guid } = event;

      trackEvent(event.name, { ...baseParams, guid });

      break;
    }
    case 'Declined Load Offer': {
      const {
        guid,
        payload: { decline_comment, decline_reasons = [] },
      } = event;

      trackEvent(event.name, {
        ...baseParams,
        guid,

        decline_reason: [...decline_reasons, decline_comment && 'Comment']
          .filter(Boolean)
          .map(startCase)
          .join(', '),
      });

      break;
    }
    default: {
      const { name, ...props } = event;
      trackEvent(event.name, { ...baseParams, ...props });
    }
  }
}
